<ejs-grid #grid class="grid-with-toolbar grid-no-filter grid-configuration" width="100%" rowHeight="38"
  [dataSource]="data" [allowSorting]="true" [allowPaging]="true" [allowFiltering]="true" [pageSettings]='pageSettings'
  [filterSettings]="filterSettings" (rowSelected)="onRowSelected($event)" (dataBound)="dataBound()">
  <e-columns>
    <e-column field="id" [visible]="false" [isPrimaryKey]="true"></e-column>
    <e-column field="name"
      headerText="{{'i18n.domain.import-configuration.acodis-workflows.workflow-form.form-fields.workflow-name' | translate}}"
      clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="importType"
      headerText="{{'i18n.domain.import-configuration.acodis-workflows.workflow-form.form-fields.import-type' | translate}}"
      clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        {{'i18n.domain.import-configuration.enums.import-type.' + ImportType[data.importType] | translate}}
      </ng-template>
    </e-column>
  </e-columns>
</ejs-grid>
